import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import DescriptionComponent from "../../../../components/common/Description/DescriptionComponent";
import TextInput from "../../../../components/common/TextInput/TextInput";
import Title from "../../../../components/common/Title/Title";
import { descriptionNotification, initForm } from "../constants";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { BiEditAlt } from "react-icons/bi";
import ModalAddlListNotification from "../components/ModalAddlListNotification";
import httpclient from "../../../../components/httpclient";
import Swal from "sweetalert2";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import SwalToast from "../../../../components/helpers/SwalToast";
import IsEmpty from "../../../../components/helpers/IsEmpty";
import AppRoutePath from "../../../../router/AppRoutePath";
import { convertDetailNotification } from "../list_notification/helpers/convertDetailNotificationGroup";

export default function AddNotification({ match }) {
  const [errors, setErrors] = useState({});
  const [name, setName] = useState();
  const [variableList, setVariableList] = useState([]);
  const [listSubNotification, setListSubNotification] = useState([]);
  const [modalAddListNotification, setModalAddListNotification] =
    useState(false);
  const [form, setForm] = useState(initForm);
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const id = match.params.id;

  const handleCloseModalAdd = () => {
    setModalAddListNotification(false);
    setForm(initForm);
    setErrors((prev) => ({ ...prev, listSubNotification: "" }));
  };

  useEffect(() => {
    getDataVariable();
    if (id) {
      getDetail();
    }
  }, []);

  const getDetail = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/${id}`;
    httpclient.GET(url).then((response) => {
      let converted = convertDetailNotification(response.data.data);
      setName(converted.name);
      setListSubNotification(converted.details);
    });
  };

  const getDataVariable = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}notification-group/variables`;
    httpclient.GET(url).then((response) => {
      setVariableList(response.data.data);
    });
  };

  const handleAddList = () => {
    if (form.index != undefined) {
      let list = [...listSubNotification];
      list[form.index] = form;
      setListSubNotification(list);
    } else {
      setListSubNotification((prev) => [...prev, { ...form }]);
    }
    handleCloseModalAdd();
  };

  const handleDeleteItemList = (value) => {
    Swal.fire({
      title: "Hapus Data",
      text: `Apakah anda yakin ingin menghapus daftar ${value.title}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2C465C",
      cancelButtonColor: "#F23434",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        let array = listSubNotification.filter((item) => item !== value);
        setListSubNotification(array);
      }
    });
  };

  const insertVariable = (variable) => {
    let text = form.desc;
    setForm((prev) => ({
      ...prev,
      ["desc"]: `${text}${variable}`,
    }));
  };

  const handleText = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    if (name === "days") {
      setForm((prev) => ({
        ...prev,
        value: parseInt(value),
        [name]: value,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleEditItemList = (item, index) => {
    setForm({ ...item, index });
    console.log(item);
    setModalAddListNotification(true);
  };

  const validate = () => {
    const newErrors = {};

    if (IsEmpty(name)) {
      newErrors.name = "Nama notifikasi tidak boleh kosong";
    }
    if (listSubNotification.length <= 0) {
      newErrors.listSubNotification = "Daftar notifikasi tidak boleh kosong";
    }
    return newErrors;
  };

  const onSubmit = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        name,
        details: listSubNotification,
      };
      console.log(JSON.stringify(data));
      setSubmitting(true);
      if (id) {
        httpclient
          .PUT(
            `${process.env.REACT_APP_BASE_API_URL}notification-group/${id}`,
            data
          )
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            history.push(AppRoutePath.NOTIFICATION_SETTING);
          })
          .catch((error) => {
            console.log(error.response.data);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data?.error?.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      } else {
        httpclient
          .POST(`${process.env.REACT_APP_BASE_API_URL}notification-group`, data)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            history.push(AppRoutePath.NOTIFICATION_SETTING);
          })
          .catch((error) => {
            console.log(error.response.data);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data?.error?.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          })
          .finally(() => {
            setSubmitting(false);
          });
      }
    }
  };
  return (
    <div>
      <div className="p-3">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="">
            <Title
              text={
                id ? "Ubah Daftar Notifikasi" : "Buat Daftar Notifikasi Baru"
              }
            />
            <Breadcrumb
              current={
                id ? "Ubah Daftar Notifikasi" : "Buat Daftar Notifikasi Baru"
              }
            />
          </div>
        </div>
        <div className="container-campaign">
          <div className="container-input-1">
            <div className="container-input my-3">
              <div
                style={{ color: "#2C465C", fontSize: 16, fontWeight: "600" }}
                className="mb-3"
              >
                Pengaturan Notifikasi
              </div>
              <TextInput
                label="Nama Notifikasi"
                handleChange={(e) => setName(e.target.value)}
                name="name"
                width="100%"
                value={name}
                errorText={errors.name}
              />
            </div>
            <div className="container-input my-3">
              <div
                style={{ color: "#2C465C", fontSize: 16, fontWeight: "600" }}
                className="mb-3"
              >
                Daftar Pengiriman Notifikasi
              </div>
              {listSubNotification &&
                listSubNotification.length > 0 &&
                listSubNotification.map((item, index) => {
                  return (
                    <div className="d-flex justify-content-between align-items-center my-3">
                      <div key={index}>{item.title}</div>
                      <div className="d-flex">
                        <BiEditAlt
                          onClick={() => handleEditItemList(item, index)}
                          style={{
                            fontSize: 22,
                            color: "#F5CB58",
                            cursor: "pointer",
                            marginRight: 10,
                          }}
                        />
                        <FaTrashAlt
                          onClick={() => handleDeleteItemList(item)}
                          size={22}
                          color="#F23434"
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  );
                })}
              <div
                className="d-flex my-2 align-items-center"
                onClick={() => setModalAddListNotification(true)}
                style={{
                  color: "#2C465C",
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: "500",
                }}
              >
                <FaPlus className="mr-2" />
                <div>Tambah Daftar Notifikasi</div>
              </div>
              {errors.listSubNotification ? (
                <span className="small text-danger">
                  {errors.listSubNotification}
                </span>
              ) : null}
            </div>
            <div className="d-flex mt-5">
              <Button
                disabled={submitting}
                key="back"
                onClick={history.goBack}
                className="btn-modal btn-default"
                style={{ width: 150, height: 40 }}
              >
                Kembali
              </Button>
              <div className="mx-2" />
              <Button
                disabled={submitting}
                key="submit"
                type="primary"
                onClick={onSubmit}
                className="btn-modal"
                style={{ width: 150, height: 40 }}
              >
                Simpan
              </Button>
            </div>
          </div>

          <DescriptionComponent data={descriptionNotification} />
        </div>
      </div>
      <ModalAddlListNotification
        visible={modalAddListNotification}
        handleClose={handleCloseModalAdd}
        variableList={variableList}
        handleAddList={handleAddList}
        insertVariable={insertVariable}
        handleText={handleText}
        form={form}
        setForm={setForm}
        defaultValue={"day"}
      />
    </div>
  );
}
